import { render, staticRenderFns } from "./BetterUptimeTable.vue?vue&type=template&id=651d1445&scoped=true"
import script from "./BetterUptimeTable.vue?vue&type=script&lang=js"
export * from "./BetterUptimeTable.vue?vue&type=script&lang=js"
import style0 from "./BetterUptimeTable.vue?vue&type=style&index=0&id=651d1445&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651d1445",
  null
  
)

export default component.exports